"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _axios = _interopRequireDefault(require("axios"));
var _validate = require("@/utils/validate");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    var _this = this;
    var validateEmpNo = function validateEmpNo(rule, value, callback) {
      if (!value) {
        callback(new Error(_this.$t('sfe.account.error.empNo')));
      } else if (_this.errorKeys.indexOf('empNo') >= 0) {
        callback(new Error(_this.errorInfo['empNo']));
        _this.resetError('empNo');
      } else {
        callback();
      }
    };
    var validateUsername = function validateUsername(rule, value, callback) {
      if (!value) {
        callback(new Error(_this.$t('sfe.account.error.username')));
      } else if (_this.errorKeys.indexOf('username') >= 0) {
        callback(new Error(_this.errorInfo['username']));
        _this.resetError('username');
      } else {
        callback();
      }
    };
    var validateEmail = function validateEmail(rule, value, callback) {
      if (!value) {
        callback(new Error(_this.$t('sfe.account.error.email')));
      } else if (_this.errorKeys.indexOf('email') >= 0) {
        callback(new Error(_this.errorInfo['email']));
        _this.resetError('email');
      } else {
        callback();
      }
    };
    var validateMobile = function validateMobile(rule, value, callback) {
      if (value && (0, _validate.validPhone)(value)) {
        callback(new Error(_this.$t('sfe.account.error.mobile')));
      } else if (_this.errorKeys.indexOf('mobile') >= 0) {
        callback(new Error(_this.errorInfo['mobile']));
        _this.resetError('mobile');
      } else {
        callback();
      }
    };
    var validateAddress = function validateAddress(rule, value, callback) {
      if ((_this.form.region || _this.form.city || _this.form.district) && !value) {
        callback(new Error(_this.$t('sfe.account.error.address')));
      } else if (_this.errorKeys.indexOf('address') >= 0) {
        callback(new Error(_this.errorInfo['address']));
        _this.resetError('address');
      } else {
        callback();
      }
    };
    return {
      pageName: 'account',
      formLabelWidth: '120px',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currentId: null,
      currentItem: {},
      isShowModel: false,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      searchVal: {},
      dialogStatus: 'create',
      form: {
        accountId: '',
        empNo: '',
        username: '',
        usernameCn: '',
        email: '',
        mobile: '',
        region: '',
        regionCode: '',
        city: '',
        cityCode: '',
        district: '',
        districtCode: '',
        address: '',
        accountStatus: 'ENABLED'
      },
      initForm: {
        accountId: '',
        empNo: '',
        username: '',
        usernameCn: '',
        email: '',
        mobile: '',
        region: '',
        regionCode: '',
        city: '',
        cityCode: '',
        district: '',
        districtCode: '',
        address: '',
        accountStatus: 'ENABLED'
      },
      rules: {
        empNo: [{
          required: true,
          trigger: ['change'],
          validator: validateEmpNo
        }],
        username: [{
          required: true,
          trigger: ['change'],
          validator: validateUsername
        }],
        email: [{
          required: true,
          trigger: ['change'],
          validator: validateEmail
        }],
        mobile: [{
          required: false,
          trigger: ['change'],
          validator: validateMobile
        }],
        address: [{
          required: false,
          trigger: ['change'],
          validator: validateAddress
        }]
      },
      errorKeys: [],
      errorInfo: {},
      lookupList: {},
      roleOptions: [],
      isShowRoleAuthModel: false,
      roleData: [],
      roleCheckList: [],
      initRoleCheckList: [],
      roleCheckArr: [],
      exportUrl: '/protected/accountInfo/export',
      regionOptions: [],
      cityOptions: [],
      districtOptions: []
    };
  },
  computed: {
    stateBtn: function stateBtn() {
      return function (state) {
        if (state.toLowerCase() === 'enabled') {
          state = 'DISABLED';
        } else {
          state = 'ENABLED';
        }
        return this.$t("common.".concat(state));
      };
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更重新请求配置查询接口
      this.getLookupTypeCode();
    }
  },
  mounted: function mounted() {
    this.fetchRegionList();
    this.getLookupTypeCode();
    this.getRoleOptions();
  },
  methods: {
    fetchRegionList: function fetchRegionList() {
      var _this2 = this;
      if (this.$store.getters.regionData.length) {
        this.regionOptions = this.$store.getters.regionData;
        return;
      }
      this.$api.common.getRegionList(3).then(function (response) {
        var responseData = response;
        if (responseData.success) {
          _this2.regionOptions = responseData.data;
          _this2.$store.dispatch('baseData/saveRegionData', responseData.data);
        }
      }).catch(function (error) {
        console.log('-----' + error);
      });
    },
    provinceChangeEvent: function provinceChangeEvent(value) {
      console.log('provinceChangeEvent', value);
      this.form.region = value.label;
      this.form.regionCode = value.value;
      if (value.children && value.children.length > 0) {
        this.cityOptions = (0, _toConsumableArray2.default)(value.children);
      }
    },
    cityChangeEvent: function cityChangeEvent(value) {
      this.form.city = value.label;
      this.form.cityCode = value.value;
      if (value.children && value.children.length > 0) {
        this.districtOptions = (0, _toConsumableArray2.default)(value.children);
      }
    },
    districtChangeEvent: function districtChangeEvent(value) {
      this.form.district = value.label;
      this.form.districtCode = value.value;
      console.log('districtChangeEvent', value);
    },
    provinceClearEvent: function provinceClearEvent() {
      this.form.region = '';
      this.form.regionCode = '';
      this.form.city = '';
      this.form.cityCode = '';
      this.form.district = '';
      this.form.districtCode = '';
      this.cityOptions = [];
      this.districtOptions = [];
    },
    cityClearEvent: function cityClearEvent() {
      this.form.city = '';
      this.form.cityCode = '';
      this.form.district = '';
      this.form.districtCode = '';
      this.districtOptions = [];
    },
    districtClearEvent: function districtClearEvent() {
      this.form.district = '';
      this.form.districtCode = '';
    },
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    getLookupTypeCode: function getLookupTypeCode() {
      var _this3 = this;
      var param = {
        configItemCodeList: ['CONFIGURATION_STATUS']
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        if (res.data) {
          _this3.lookupList = res.data || {};

          // 查找值数据转换
          for (var key in _this3.lookupList) {
            _this3.generateMapping(key, _this3.lookupList[key] || []);
          }
          _this3.searchData();
        }
      }).catch(function () {});
    },
    generateMapping: function generateMapping(title, dataList) {
      var _this4 = this;
      // 将查找值转换成所需数据格式
      this.lookupList["".concat(title, "_MAPPING")] = {};
      dataList.forEach(function (item) {
        var name = item.name,
          code = item.code;
        _this4.lookupList["".concat(title, "_MAPPING")][code] = name;
      });
    },
    fetchData: function fetchData() {
      var _this5 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: (0, _objectSpread2.default)({}, this.searchVal)
      };
      this.listLoading = true;
      this.$api.account.getList(param, this.sourceApi.token).then(function (res) {
        _this5.listLoading = false;
        _this5.list = res.data.items;
        _this5.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this5.listLoading = false;
      });
    },
    resetData: function resetData() {
      this.searchVal = {};
      this.searchData();
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    refreshData: function refreshData() {
      this.fetchData();
    },
    getRoleOptions: function getRoleOptions() {
      var _this6 = this;
      return new Promise(function (resolve) {
        var param = {
          currPage: 1,
          limit: 10000,
          smodel: {}
        };
        _this6.$api.role.getList(param).then(function (res) {
          _this6.roleOptions = res.data.items || [];
          resolve('success');
        }).catch(function () {
          console.log('Data Request Fail');
        });
      });
    },
    switchState: function switchState(row, index) {
      var _this7 = this;
      if (row.accountStatus.toLowerCase() === 'enabled') {
        this.$confirm(this.$t('common.confirm5'), this.$t('common.tip'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(function () {
          _this7.isLoading = true;
          _this7.$api.account.disabledItem({
            accountId: row.accountId,
            accountStatus: 'DISABLED'
          }).then(function (res) {
            _this7.$message.success(_this7.$t('common.disableSuccess'));
            _this7.$set(_this7.list[index], 'accountStatus', 'DISABLED');
            _this7.isLoading = false;
          }).catch(function () {
            // this.$message.error('删除失败')
            _this7.isLoading = false;
          });
        }).catch(function () {});
      } else {
        this.$confirm(this.$t('common.confirm6'), this.$t('common.tip'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(function () {
          _this7.isLoading = true;
          _this7.$api.account.enableItem({
            accountId: row.accountId,
            accountStatus: 'ENABLED'
          }).then(function (res) {
            _this7.$message.success(_this7.$t('common.enableSuccess'));
            _this7.$set(_this7.list[index], 'accountStatus', 'ENABLED');
            _this7.isLoading = false;
          }).catch(function () {
            // this.$message.error('删除失败')
            _this7.isLoading = false;
          });
        }).catch(function () {});
      }
    },
    create: function create() {
      var _this8 = this;
      this.dialogStatus = 'create';
      this.form = {
        accountId: '',
        empNo: '',
        username: '',
        usernameCn: '',
        email: '',
        mobile: '',
        region: '',
        regionCode: '',
        city: '',
        cityCode: '',
        district: '',
        districtCode: '',
        address: '',
        accountStatus: 'ENABLED'
      };
      this.initForm = {
        accountId: '',
        empNo: '',
        username: '',
        usernameCn: '',
        email: '',
        mobile: '',
        region: '',
        regionCode: '',
        city: '',
        cityCode: '',
        district: '',
        districtCode: '',
        address: '',
        accountStatus: 'ENABLED'
      };
      this.isShowModel = true;
      this.$nextTick(function () {
        _this8.$refs['dataForm'].clearValidate();
      });
    },
    edit: function edit(row) {
      var _this9 = this;
      this.dialogStatus = 'edit';
      this.currentId = row.accountId;
      if (this.currentId === null) {
        return;
      }
      this.getDetail().then(function (res) {
        _this9.isShowModel = true;
        _this9.$nextTick(function () {
          _this9.$refs['dataForm'].clearValidate();
        });
      });
    },
    getDetail: function getDetail() {
      var _this0 = this;
      return new Promise(function (resolve) {
        _this0.isLoading = true;
        _this0.$api.account.getDetail(_this0.currentId).then(function (res) {
          _this0.isLoading = false;
          var _res$data = res.data,
            accountId = _res$data.accountId,
            empNo = _res$data.empNo,
            username = _res$data.username,
            usernameCn = _res$data.usernameCn,
            email = _res$data.email,
            mobile = _res$data.mobile,
            region = _res$data.region,
            regionCode = _res$data.regionCode,
            city = _res$data.city,
            cityCode = _res$data.cityCode,
            district = _res$data.district,
            districtCode = _res$data.districtCode,
            address = _res$data.address,
            accountStatus = _res$data.accountStatus;
          _this0.form = {
            accountId: accountId,
            empNo: empNo,
            username: username,
            usernameCn: usernameCn,
            email: email,
            mobile: mobile,
            region: region,
            regionCode: regionCode,
            city: city,
            cityCode: cityCode,
            district: district,
            districtCode: districtCode,
            address: address,
            accountStatus: accountStatus
          };
          _this0.initForm = {
            accountId: accountId,
            empNo: empNo,
            username: username,
            usernameCn: usernameCn,
            email: email,
            mobile: mobile,
            region: region,
            regionCode: regionCode,
            city: city,
            cityCode: cityCode,
            district: district,
            districtCode: districtCode,
            address: address,
            accountStatus: accountStatus
          };
          _this0.initCityOptions();
          _this0.initDistrictOptions();
          resolve(_this0.form);
        }).catch(function () {
          _this0.isLoading = false;
          console.log('Data Request Fail');
        });
      });
    },
    initCityOptions: function initCityOptions() {
      for (var i = 0; i < this.regionOptions.length; i++) {
        if (this.form.regionCode === this.regionOptions[i].value) {
          this.cityOptions = this.regionOptions[i].children;
        }
      }
    },
    initDistrictOptions: function initDistrictOptions() {
      for (var i = 0; i < this.cityOptions.length; i++) {
        if (this.form.cityCode === this.cityOptions[i].value) {
          this.districtOptions = this.cityOptions[i].children;
        }
      }
    },
    deleteItem: function deleteItem(row) {
      var _this1 = this;
      this.$confirm(this.$t('common.confirm1'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this1.isLoading = true;
        _this1.$api.account.deleteItem([row.accountId]).then(function (res) {
          _this1.$message.success(_this1.$t('common.deleteSuccess'));
          _this1.isLoading = false;
          _this1.refreshData();
        }).catch(function () {
          _this1.isLoading = false;
        });
      }).catch(function () {});
    },
    saveItem: function saveItem() {
      var _this10 = this;
      this.$refs['dataForm'].clearValidate();
      this.$refs.dataForm.validate(function (valid) {
        if (!valid) return;
        _this10.isLoading = true;
        _this10.$api.account.saveItem(_this10.form).then(function (res) {
          _this10.$message.success(_this10.$t('common.saveSuccess'));
          _this10.isLoading = false;
          _this10.isShowModel = false;
          _this10.refreshData();
        }).catch(function (err) {
          if (err.errorInfos && err.errorInfos.length > 0) {
            _this10.resetError();
            err.errorInfos.forEach(function (item) {
              _this10.errorKeys.push(item.key);
              _this10.errorInfo[item.key] = item.errMsg;
            });
            _this10.$refs['dataForm'].validate(function (valid) {
              console.log(valid);
            });
          }
          _this10.isLoading = false;
          // this.$message.error('保存失败')
        });
      });
    },
    resetError: function resetError(val) {
      if (val) {
        var index = this.errorKeys.indexOf(val);
        this.errorKeys.splice(index, 1);
        delete this.errorInfo.val;
      } else {
        this.errorKeys = [];
        this.errorInfo = {};
      }
    },
    roleAuth: function roleAuth(row) {
      var _this11 = this;
      this.dialogStatus = 'roleAuth';
      this.currentId = row.accountId;
      this.currentItem = row;
      if (this.currentId === null) {
        return;
      }
      this.getAuthDetail(row).then(function (res) {
        _this11.isShowRoleAuthModel = true;
        _this11.$nextTick(function () {
          _this11.roleData.forEach(function (item) {
            if (_this11.roleCheckList.includes(item.roleCode)) {
              _this11.$refs.roleTable.toggleRowSelection(item, true);
            } else {
              _this11.$refs.roleTable.toggleRowSelection(item, false);
            }
          });
        });
      });
    },
    getAuthDetail: function getAuthDetail(row) {
      var _this12 = this;
      return new Promise(function (resolve) {
        _this12.roleData = _this12.roleOptions;
        var roles = row.roleCode ? row.roleCode.split(',') : [];
        _this12.roleCheckList = roles.map(function (item) {
          return item;
        });
        _this12.initRoleCheckList = roles.map(function (item) {
          return item;
        });
        _this12.roleCheckArr = [];
        _this12.roleData.forEach(function (item, index) {
          if (_this12.roleCheckList.includes(item.roleCode)) {
            _this12.roleCheckArr[index] = true;
          } else {
            _this12.roleCheckArr[index] = false;
          }
        });
        resolve('success');
      });
    },
    saveRoleAuthItem: function saveRoleAuthItem() {
      var _this13 = this;
      this.isLoading = true;
      var roles = this.roleData.filter(function (item) {
        return _this13.roleCheckList.includes(item.roleCode);
      });
      this.$api.account.roleInfoSave({
        accountId: this.currentId,
        roleVoList: roles
      }).then(function (res) {
        _this13.$message.success(_this13.$t('common.authSuccess'));
        _this13.isLoading = false;
        _this13.isShowRoleAuthModel = false;
        _this13.refreshData();
      }).catch(function () {
        _this13.isLoading = false;
        // this.$message.error('保存失败')
      });
    },
    getRoleKeys: function getRoleKeys(row) {
      return row.roleCode; // id为列表数据的唯一标识
    },
    handleCheck: function handleCheck(index, val) {
      var _this14 = this;
      if (val) {
        this.roleCheckList.push(this.roleData[index].roleCode);
      } else {
        this.roleCheckList = this.roleCheckList.filter(function (item) {
          return item !== _this14.roleData[index].roleCode;
        });
        if (this.roleCheckList.length === 0) {
          this.roleCheckArr[index] = true;
          this.roleCheckList.push(this.roleData[index].roleCode);
        }
      }
    },
    exportHandler: function exportHandler() {
      var param = (0, _objectSpread2.default)({}, this.searchVal);
      this.exportReport(param);
    },
    exportReport: function exportReport(param) {
      var _this15 = this;
      if (this.isLoading) return;
      this.isLoading = true;
      var promiseFn = this.$api.account.exportReportFile;
      var fileName = this.$t("sfe.route.account");
      promiseFn(this.exportUrl, param).then(function (res) {
        _this15.isLoading = false;
        (0, _utils.downloadFileExcel)(fileName, res.data);
      }).catch(function () {
        _this15.isLoading = false;
      });
    }
  }
};